// extracted by mini-css-extract-plugin
export var actionText = "_ob-4";
export var container = "_ob-0";
export var leftSection = "_ob-1";
export var rightSection = "_ob-2";
export var settingsButton = "_ob-6";
export var settingsIcon = "_ob-7";
export var shortcut = "_ob-5";
export var shortcutGroup = "_ob-3";